import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Typography } from '@mui/material';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';

import EmptyState from '../../../../../../../DesignSystem/EmptyState';
import useCurrentUser from '../../../../../../../../Hooks/useCurrentUser';

function ActionButton() {
  const { logout } = useCurrentUser();

  const onClick = async () => {
    await logout();
    window.history.replaceState(null, '', window.location.pathname);
    window.location.reload();
  };

  return (
    <Button onClick={onClick} size="large" color="primary" variant="contained">
      <FormattedMessage id="BUTTONS.CHANGE_USER" />
    </Button>
  );
}

function EmptyAnswered() {
  return (
    <EmptyState
      content={
        <Typography variant="body1">
          <FormattedMessage id="POSTS.DETAILS.STUDY.POST_SIDE_DESCRIPTION.ONGOING_ANSWERED" />
        </Typography>
      }
      icon={<CheckCircleIcon color="primary" />}
      action={<ActionButton />}
    />
  );
}

export default EmptyAnswered;
